export default "__VITE_ASSET__ee4b19d1__"